import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/storia", label: "25 Anni" },
  { to: "/calcolatore", label: "Calcolatore" },
  { to: "/mutui", label: "Mutui" },
  { to: "/vendita", label: "Vendite" },
  { to: "/affitti", label: "Affitti" },
];

const Logo = ({ compact = false }) => (
  <img
    src="/logo-ascari.png"
    alt="Logo Agenzia Immobiliare Ascari Home Consulting"
    className={compact ? "h-14 w-auto" : "h-16 md:h-20 w-auto"}
  />
);

export { Logo };

export default function Nav() {
  const [open, setOpen] = useState(false);

  return (
    <nav
      data-testid="main-nav"
      className="sticky top-0 z-50 bg-[var(--card)]/90 backdrop-blur border-b border-[var(--ink)]/10 px-6 py-3"
    >
      <div className="max-w-6xl mx-auto flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-4" data-testid="nav-logo-link">
          <Logo />
          <span className="font-display font-extrabold text-base md:text-lg uppercase tracking-[0.18em] text-[var(--gold-deep)] leading-tight">
            Agenzia<br />Immobiliare
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-6 font-mono-lbl text-xs uppercase tracking-wider text-[var(--ink)]/80">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
              className={({ isActive }) =>
                `transition-colors hover:text-[var(--gold-deep)] ${isActive ? "text-[var(--gold-deep)] font-semibold" : ""}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <Link
            to="/#contatto"
            data-testid="nav-cta-perizia"
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2 bg-[var(--ink)] text-[var(--gold-light)] font-mono-lbl text-xs uppercase tracking-wider rounded-md hover:bg-[var(--gold)] hover:text-[var(--ink)] transition-colors"
          >
            <span className="w-2 h-2 rounded-full bg-[var(--gold)] asc-pulse"></span>
            <span>Richiedi Perizia</span>
          </Link>
          <button
            type="button"
            data-testid="nav-mobile-toggle"
            aria-label="Apri menu"
            onClick={() => setOpen(!open)}
            className="md:hidden p-2 text-[var(--ink)]"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden mt-4 pt-4 border-t border-[var(--ink)]/10 flex flex-col gap-4 font-mono-lbl text-xs uppercase tracking-wider"
        >
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="text-[var(--ink)]/80 hover:text-[var(--gold-deep)] transition-colors"
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/#contatto"
            onClick={() => setOpen(false)}
            data-testid="nav-mobile-cta-perizia"
            className="inline-flex items-center gap-2 text-[var(--gold-deep)] font-semibold"
          >
            Richiedi Perizia →
          </Link>
        </div>
      )}
    </nav>
  );
}
